import React from 'react';

import { PlayNumbers } from './PlayNumbers';
import { DrawNumbers } from './DrawNumbers';
import { ExpandLess, ExpandMore } from "@mui/icons-material"
import MarketingContext from '../../../contexts/MarketingContext';
import "./marketing.css"

export const Roulette = () => {


     let {
        displayroulette,
        onDisplayRoulette,

        drawnumbers_low,
        drawnumbers_middle,
        drawnumbers_high,

        playnumbers_low,
        playnumbers_middle,
        playnumbers_high,

      } = React.useContext(MarketingContext);

  return (

    <div className="homeContainer">
        
          
      <div className="aitestactionbutton" onClick={() => { onDisplayRoulette() }}>
        {
          (displayroulette) ?
            <ExpandLess className="aitestIcon" />
              :
            <ExpandMore className="aitestIcon" />
        }
       Roulette
      </div>

      <div>
        {
          displayroulette &&
        <>
       
  
        <label style={{fontWeight: 'bold', fontSize:'20px'}}>Draw numbers:</label>
        <br></br><br></br>

        
        <DrawNumbers title={'Low numbers:'} group={'low'}  numbers={drawnumbers_low}/>
        <br></br>


        <DrawNumbers title={'Middle numbers:'} group={'middle'} numbers={drawnumbers_middle}/>
        <br></br>

        <DrawNumbers title={'High numbers:'} group = {'high'} numbers={drawnumbers_high}/>
        <br></br>


        <br></br>
        <label style={{fontWeight: 'bold', fontSize:'20px'}}>Play numbers:</label>
        <br></br><br></br>

        
        <PlayNumbers title={'Low numbers:'} group={'low'}  numbers={playnumbers_low}/>
        <br></br>


        <PlayNumbers title={'Middle numbers:'} group={'middle'} numbers={playnumbers_middle}/>
        <br></br>

        <PlayNumbers title={'High numbers:'} group = {'high'} numbers={playnumbers_high}/>
        <br></br>

        <hr style={{borderWidth:'5px', color:'black'}}></hr>

        <label style={{fontSize:'20px', fontWeight:'bold'}}>Total: {playnumbers_low.length + playnumbers_middle.length + playnumbers_high.length}</label>
        </>
      }
        </div>
     </div>
  )
}


